'use client';

import styled from 'styled-components';

import {
  ManualSidebar,
  ManualSidebarClose,
} from '@/ui/components/Manual/Sidebar/index.styled';
import { device } from '@/ui/styles/breakpoints';

export const AllWrap = styled.div`
  display: flex;
  flex-flow: column;
  height: 100%;
  padding-left: 20px;
  padding-right: 20px;

  @media ${device.max.md} {
    padding-left: 0;
    padding-right: 0;
  }
`;

export const ManualWrap = styled.div`
  @media ${device.max.md} {
    background: ${props => props.theme.palette.gray.light};
    height: 100%;
  }
`;

type BreadcrumbsProps = {
  $isFullscreen: boolean;
};

export const BreadcrumbsLogo = styled.div<BreadcrumbsProps>`
  display: ${props => (props.$isFullscreen ? 'block' : 'none')};
  height: 70px;
  padding-bottom: 10px;
  padding-top: 10px;

  img {
    height: 50px !important;
  }
`;

export const BreadcrumbsHiddenForMobile = styled.div<{
  $isFullscreen: boolean;
}>`
  ${props =>
    props.$isFullscreen &&
    `
    display: flex;
    align-items: center;
    gap: 20px;
    border-bottom: 1px #E0E0E0 solid;
    margin-left: -20px;
    margin-right: -20px;
    padding-left: 20px;
    padding-right: 20px;
  `}

  @media ${device.max.md} {
    display: none;
  }
`;

export const ManualTitle = styled.div`
  background: ${props => props.theme.palette.gray.light};
  align-items: center;
  display: flex;
  justify-content: space-between;
  overflow: hidden;
  padding: 1rem;
  position: relative;
  white-space: nowrap;

  @media ${device.max.md} {
    flex-shrink: 0;
  }

  @media ${device.min.md} {
    flex: 1;
  }

  h1 {
    overflow: hidden;
    text-overflow: ellipsis;
  }

  button {
    flex-shrink: 0;
    margin-left: 1rem;
  }

  @media ${device.min.md} {
    &:before {
      background: ${props => props.theme.palette.gray.light};
      content: '';
      display: block;
      left: 0;
      height: 100%;
      position: absolute;
      top: 0;
      width: 100vw;
      z-index: -1;
    }
  }
`;

type ManualSidebarShowProps = {
  $isTabOpen?: boolean;
};

export const ManualSidebarShow = styled.button<ManualSidebarShowProps>`
  background: transparent;
  border: 0;
  display: block;
  height: 17px;
  position: relative;
  width: 17px;
  z-index: 2;

  @media ${device.min.md} {
    display: none;
  }

  svg {
    cursor: pointer;
    height: 100%;
    left: 0;
    opacity: 0.2;
    position: absolute;
    top: 0;
    transform: ${props => (props.$isTabOpen ? 'rotate(180deg)' : 'none')};
    width: 100%;
  }
`;

export const ManualNavigation = styled.div`
  background: ${props => props.theme.palette.gray.light};
  align-items: center;
  display: flex;

  @media ${device.max.md} {
    border-top: 1px ${props => props.theme.palette.gray.main} solid;
    justify-content: space-between;
    order: 3;
    bottom: 0;
    left: 0;
    position: fixed;
    width: 100%;
    z-index: 2;
  }

  a,
  button {
    background: transparent;
    border: 0;
    color: #333;
    cursor: pointer;
    font-size: 13px;
    font-style: normal;
    font-weight: 700;
    line-height: 16px;
    padding: 10px;
    text-decoration: none;

    &:not(:first-child) {
      margin-left: 20px;
    }

    &.fullscreen {
      &:after {
        background: #9e9e9e;
        border-radius: 2px;
        color: ${props => props.theme.palette.background.default};
        content: 'F';
        display: inline-block;
        font-size: 10px;
        font-weight: 700;
        height: 16px;
        line-height: 16px;
        margin-left: 10px;
        text-align: center;
        text-decoration: none;
        vertical-align: middle;
        width: 16px;
      }
    }

    &.orange {
      color: ${props => props.theme.palette.primary.main};
    }

    &:hover {
      text-decoration: underline;

      &:after {
        text-decoration: none;
      }
    }

    &:focus {
      outline: 0;
    }
  }

  button {
    @media ${device.max.md} {
      display: none;
    }
  }
`;

export const ManualStep = styled.div`
  display: none;

  @media ${device.max.md} {
    display: block;
    font-size: 12px;
    line-height: 14px;
    padding: 10px;
  }
`;

export const Tabs = styled.div`
  display: flex;
  height: 100%;
  margin-left: 20px;
`;

type TabProps = {
  $isActive: boolean;
  $orange?: boolean;
  $mobileVisible?: boolean;
};

export const Tab = styled.div<TabProps>`
  align-items: center;
  border-bottom: 2px transparent solid;
  border-bottom-color: ${props =>
    props.$isActive ? 'inherit' : 'transparent'};
  display: flex;
  color: ${props =>
    props.$orange ? props.theme.palette.primary.main : '#333'};
  display: flex;
  font-size: 13px;
  font-style: normal;
  font-weight: 700;
  line-height: 16px;
  padding: 0 10px;

  @media ${device.max.md} {
    display: ${props => (props.$mobileVisible ? 'block' : 'none')};
    padding: 0;
  }

  &:not(:first-child) {
    margin-left: 20px;
  }

  span {
    cursor: pointer;
    display: block;
    padding: 10px;

    @media ${device.max.md} {
      text-decoration: underline;
    }

    &:hover {
      text-decoration: underline;
    }
  }
`;

type HasArrowsProps = {
  $hasArrows: boolean;
};

export const ManualMainWrap = styled.div<HasArrowsProps>`
  background: ${props => props.theme.palette.gray.light};
  display: flex;
  flex-flow: column;
  position: relative;
  width: 100%;
  z-index: 1;

  @media ${device.max.md} {
    height: ${props =>
      props.$hasArrows ? 'calc(100dvh - 86px)' : 'calc(100dvh - 147px)'};
    overflow: hidden;
  }

  @media ${device.min.md} {
    flex-flow: row;
    flex-wrap: wrap;
    height: 100%;
    overflow: hidden;
    justify-content: space-between;
  }
`;

export const ManualLoading = styled.div`
  align-items: center;
  background: rgba(255, 255, 255, 0.9);
  display: flex;
  height: 100%;
  left: 0;
  justify-content: center;
  position: fixed;
  top: 0;
  width: 100%;
  z-index: 2;

  @media ${device.max.md} {
    overflow: hidden;
  }
`;

export const ManualMainMain = styled.div`
  background: ${props => props.theme.palette.background.default};
  display: flex;
  height: 100%;
  width: 100%;

  @media ${device.max.md} {
    overflow: hidden;
  }
`;

export const ManualMain = styled.div`
  background: ${props => props.theme.palette.background.default};
  display: flex;
  flex: 0 0 100%;
  height: calc(100% - 51px);
  /* padding-bottom: 20px; */
  padding-top: 20px;
  width: 100%;

  @media ${device.max.md} {
    flex-flow: column;
    height: 100%;
    padding-top: 0;
    padding-bottom: 0;
  }
`;

export const ManualContent = styled.div`
  display: block;
  margin-right: 20px;
  padding-right: 20px;
  overflow: hidden;
  width: 100%;

  @media ${device.min.md} {
    max-height: calc(100dvh - 223px);
    overflow-x: hidden;
    overflow-y: auto;
    padding-bottom: 20px;
  }

  @media ${device.max.md} {
    -webkit-overflow-scrolling: touch;
    height: 100%;
    //height: calc(100dvh - 453px);
    overflow-x: hidden;
    overflow-y: auto;
    order: 2;
    scroll-behavior: smooth;
    padding-bottom: 80px;
    padding-left: 10px;
    padding-right: 10px;
  }
`;

type IsTabOpenProps = {
  $isTabOpen: boolean;
};

export const ManualPhoto = styled.div<IsTabOpenProps>`
  display: flex;
  flex-shrink: 0;
  flex-flow: column;
  width: 64%;

  ${props =>
    !props.$isTabOpen &&
    `
  @media (max-height: 950px) and (min-width: 901px) {
    height: 100%;
    min-width: 385px;
    // width: calc((100dvh - 300px) * (768 / 576)); // 375px
  }
  `}

  @media ${device.max.md} {
    order: 1;
    width: 100%;
  }

  img {
    display: block;
  }
`;

export const ManualPhotoControls = styled.div`
  display: flex;
  flex-wrap: wrap;
  margin-bottom: 20px;
  margin-top: 20px;

  @media ${device.max.md} {
    justify-content: space-around;
    margin-bottom: 15px;
    margin-top: 10px;
  }
`;

export const ManualPhotoSlider = styled.div`
  display: flex;
  width: 385px;

  @media ${device.max.md} {
    width: auto;
  }
`;

type ManualPhotoSliderImgProps = {
  $isActive: boolean;
};

export const ManualPhotoSliderImg = styled.img<ManualPhotoSliderImgProps>`
  outline: ${props => (props.$isActive ? '4px' : '1px')} transparent solid;
  outline-color: ${props =>
    props.$isActive
      ? props.theme.palette.primary.main
      : props.theme.palette.gray.main};
  outline-offset: ${props => (props.$isActive ? '-4px' : '-1px')};
  cursor: pointer;
  height: 85px;
  width: 115px;

  @media ${device.max.md} {
    height: 40px;
    width: 53px;
  }

  &:not(:first-child) {
    margin-left: 20px;
  }
`;

export const ManualPhotoArrows = styled.div<IsTabOpenProps>`
  display: flex;
  //flex: ${props => (props.$isTabOpen ? '0 0 100%' : 'auto')};
  flex: auto;
  gap: 20px;
  margin-left: auto;
  padding-top: 20px;
  justify-content: flex-end;

  @media ${device.max.md} {
    background: ${props => props.theme.palette.gray.light};
    border-top: 1px ${props => props.theme.palette.gray.main} solid;
    bottom: 39px;
    gap: 10px;
    justify-content: center;
    left: 0;
    padding: 10px;
    position: fixed;
    width: 100%;
  }
`;

type ManualPhotoButtonProps = {
  $disabled?: boolean;
  $orange?: boolean;
  $wide?: boolean;
};

export const ManualPhotoButton = styled.button<ManualPhotoButtonProps>`
  align-items: center;
  background: ${props =>
    props.$orange ? props.theme.palette.primary.main : '#9e9e9e'};
  border: 0;
  border-radius: 2px;
  color: ${props => props.theme.palette.background.default};
  cursor: ${props => (props.$disabled ? 'disabled' : 'pointer')};
  font-size: 14px;
  font-weight: 700;
  display: flex;
  height: 40px;
  justify-content: center;
  min-width: 40px;
  opacity: ${props => (props.$disabled ? '.2' : '1')};
  ${props =>
    props.$wide &&
    `
    padding-left: 30px;
    padding-right: 30px;
  `}
  text-align: center;

  span {
    margin-right: 10px;
  }

  &:hover {
    background: ${props =>
      props.$orange ? props.theme.palette.primary.dark : '#858585'};
  }

  @media ${device.max.md} {
    width: ${props => (props.$orange ? '100%' : 'auto')};
  }
`;

type FullscreenProps = {
  $isFullscreen: boolean;
};

export const FullscreenWrap = styled.div<FullscreenProps>`
  background: ${props => props.theme.palette.background.default};
  display: flex;
  flex-flow: column;
  height: 100%;
  padding: ${props => (props.$isFullscreen ? '0 20px 20px' : '0')};
  flex: 1 1 auto;
  min-height: 0;
`;

type ManulWrapWrapWrapProps = {
  $isFullscreen: boolean;
  $isTabOpen: boolean;
  $hasArrows: boolean;
};

export const ManualWrapWrap = styled.div<ManulWrapWrapWrapProps>`
  background: ${props => props.theme.palette.background.default};
  height: 100%;

  @media ${device.max.md} {
    height: ${props =>
      props.$hasArrows ? 'calc(100dvh - 201px)' : 'calc(100dvh - 141px)'};
  }

  @media ${device.max.sm} {
    height: ${props =>
      props.$hasArrows ? 'calc(100dvh - 86px)' : 'calc(100dvh - 147px)'};
  }

  @media ${device.min.md} {
    display: flex;
    flex-grow: 1;
    overflow: hidden;

    ${ManualWrap} {
      align-items: flex-start;
      display: flex;
      height: ${props => (props.$isFullscreen ? '100%' : 'auto')};
      min-height: 460px;
      width: 100%;
    }

    ${ManualMainMain} {
      ${props =>
        !props.$isTabOpen &&
        props.$isFullscreen &&
        `
        @media (max-height: 950px) {
          height: calc(100% - 51px);
        }
        `}
    }

    ${ManualPhoto} {
      ${props =>
        !props.$isTabOpen &&
        props.$isFullscreen &&
        `
          height: calc(100dvh - 160px);
          // width: calc((100dvh - 265px) * (768 / 576));
        `}
    }
  }

  @media ${device.max.md} {
    ${ManualMainWrap} {
      height: ${props => (props.$isTabOpen ? 'auto' : '100%')};
    }
    ${ManualMain} {
      display: ${props => (props.$isTabOpen ? 'none' : 'flex')};
    }
    ${ManualNavigation} {
      display: ${props => (props.$isTabOpen ? 'none' : 'flex')};
    }
    ${ManualSidebar} {
      display: ${props => (props.$isTabOpen ? 'flex' : 'none')};

      h3 {
        display: ${props => (props.$isTabOpen ? 'none' : 'block')};
      }
    }
    ${ManualSidebarClose} {
      display: ${props => (props.$isTabOpen ? 'none' : 'block')};
    }
  }
`;
